(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-brand"]) return;
  try {
    
    const cards = document.body.querySelectorAll('.el_cardProduct')
    const min = 1
    const max = 15

    cards.forEach( elm => {
        const rand = Math.floor( Math.random() * (max + 1 - min) ) + min
        elm.dataset.frame = 's' + rand
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-category"]) return;
  try {
    
    const cards = document.body.querySelectorAll('.el_cardProduct')
    const min = 1
    const max = 15

    cards.forEach( elm => {
        const rand = Math.floor( Math.random() * (max + 1 - min) ) + min
        elm.dataset.frame = 's' + rand
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-ranking"]) return;
  try {
    
    const cards = document.body.querySelectorAll('.p_home_ranking .el_cardProduct')
    const min = 1
    const max = 15

    cards.forEach( elm => {
        const rand = Math.floor( Math.random() * (max + 1 - min) ) + min
        elm.dataset.frame = 's' + rand
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-recommend"]) return;
  try {
    
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
  
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
  
          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('product-recommendations');
              this._setFrame(recommendations)
              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }
              return recommendations
            })
            .catch(e => {
              console.error(e);
            });
        }
  
        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
      }

      _setFrame (html){
        //console.log(html)
        const cards = html.querySelectorAll('.el_cardProduct')
        const min = 1
        const max = 15
  
        cards.forEach( elm => {
          const rand = Math.floor( Math.random() * (max + 1 - min) ) + min
          elm.dataset.frame = 's' + rand
        })
      }
    }
    customElements.define('product-recommendations', ProductRecommendations);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
const images = document.querySelectorAll('.p_news_rowMainArticleContent img')
const image  = new Image()
for (const img of images) {
  image.src = img.getAttribute('src')
  const ratio = image.width / image.height
  if(ratio <= 1) img.classList.add('h_vertical')
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-original"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const chart_array = {
    "floral": "フローラル",
    "nutty": "ナッティー",
    "fruity": "フルーティー",
    "sour": "サワー",
    "bitter": "ビター",
    "sweet": "スウィート",
    "smokey": "スモーキー（燻製感）",
    "spicy": "スパイシー（香辛料）",
    "roast": "ロースト（香ばしさ）",
    "aroma": "アロマ（香り）",
    "woody": "ウッディー（樹々の風味）",
    "earthy": "アーシー（土っぽさ）",
    "character": "キャラクター（個性）",
    "milky": "ミルキー（ミルク感）",
    "melty": "メルティー（口溶け）",
    "ritch": "リッチ（コク）（ボディ感）",
    "hard": "ハード（固さ）",
    "citrus": "シトラス",
    "raisin": "レーズン",
    "berry": "ベリー",
    "liqueur": "リキュール（洋酒）",
    "cafe": "カフェ（コーヒー・紅茶）",
    "caramel": "キャラメル",
    "mineral": "ミネラル",
    "salty": "ソルティー",
    "pomp": "華やかさ",
    "acidity": "酸味",
    "nigami": "苦味",
    "shibumi": "渋味",
    "fruits": "フルーツ調",
    "banana": "バナナ調",
    "green": "グリーン調",
    "peanut": "ピーナッツ調",
    "roasted": "ロースト調",
    "mushroom": "マッシュルーム調",
    "bergamot": "ベルガモット",
    "herbal": "ハーブ調",
    "anise": "アニス調",
    "rose": "バラ調",
    "honey": "はちみつ調",
    "paprika": "パプリカ調",
    "carameltone": "キャラメル調",
    "metallic": "金属様 ",
    "vanilla": "バニラ"
  }
  const chart = document.getElementById('myChart')
  const ctx = chart.getContext('2d')
  const str_keys = chart.dataset.keys
  const str_vals = chart.dataset.values
  const arr_keys = str_keys.split(',')
  const arr_vals = str_vals.split(',')
  const labels_array = arr_keys.map(i => chart_array[i])
  const myChart = new Chart(ctx, {
    type: 'radar',
    data: {
      labels: labels_array,
      datasets: [
        {
          label: '',
          data: arr_vals,
          backgroundColor: 'rgba(142, 105, 18, 0.3)',
          borderWidth: 0,
          pointRadius: 0
        }
      ]
    },
    options: {
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          enabled: false
        }
      },
      scales: {
        r: {
          min: 0,
          max: 5,
          ticks: {
            display: false,
            stepSize: 1
          }
        }
      }
    }
  })

  const btn_quantity = document.body.querySelectorAll('button.quantity__button');
  const btn_add = document.body.querySelector('button.product-form__submit');
  const quantity = document.body.querySelector('input[name="quantity"]');
  const notice = document.body.querySelector('.p_productDetail_rowInfoNotice');
  btn_quantity.forEach(btn => {
    btn.addEventListener("click", () => {
      const stock = document.body.querySelector('.p_productDetail_rowInfoStockNum');
      const max = Number(stock.innerText.trim());
      const order = Number(quantity.value);
      if(order >= max){
          btn_quantity[1].style.pointerEvents = "none";
          notice.classList.add("-show");
      }else{
          btn_quantity[1].style.pointerEvents = "auto";
          notice.classList.remove("-show");
      }
    })
  });

//change text
  window.addEventListener('load', (event) => {
    const thanksHeader  = document.body.querySelector(".yotpo-thank-you[data-type='pending-for-review-approval'] .yotpo-thankyou-header");
    //const thanksContent = document.body.querySelector(".yotpo-thankyou-content");
    if(thanksHeader){
      const sp = thanksHeader.querySelectorAll("span");
      sp[1].innerText = "お客様のレビューが送信されました。運営側にて審査の上、公開作業を行います。";
      console.log(sp[1]);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  window.addEventListener('load', (event) => {
    const reslutEmpty = document.body.querySelector(".result-empty-search");
    if(reslutEmpty){
      const ahref = reslutEmpty.querySelector("a");
      ahref.setAttribute('href', 'https://lisle-chocolat.myshopify.com/search?sort=created-descending&type=items');
      ahref.innerText = "商品一覧ページ";
      console.log(ahref);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"]) return;
  try {
    
const hash = location.hash
const items = document.body.querySelectorAll('.bl_subpage_rowNavStickey li')
items.forEach(item=>{
    if(!hash==""){
        item.classList.remove("is_current")
        const bid = "#"+item.dataset.bid
        if(hash == bid){
            item.classList.add("is_current")
        }
    }

    item.addEventListener('click',()=>{
        const current = document.body.querySelector('.bl_subpage_rowNavStickey li.is_current')
        current.classList.remove("is_current")
        item.classList.add("is_current")
    })
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-guide"]) return;
  try {
    
const hash = location.hash
const items = document.body.querySelectorAll('.bl_subpage_rowNavStickey li')
items.forEach(item=>{
    if(!hash==""){
        item.classList.remove("is_current")
        const bid = "#"+item.dataset.bid
        if(hash == bid){
            item.classList.add("is_current")
        }
    }

    item.addEventListener('click',()=>{
        const current = document.body.querySelector('.bl_subpage_rowNavStickey li.is_current')
        current.classList.remove("is_current")
        item.classList.add("is_current")
    })
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recent"]) return;
  try {
    
  window.onload = async function(){
    await get_recent()
    set_recent()
    set_frame()
  }

  function set_recent(){
    const product = document.body.querySelector('[data-pid]').dataset;
    const recent_start = JSON.parse(localStorage.getItem( 'recent_views'));
    let recent_views = [{
      id:     product.pid,
      tn:     product.tn,
      title:  product.title,
      vendor: product.vendor,
      price:  product.price,
      url:    product.url
    }];
    if(recent_start){
      for(let i=0;i<5;i++){
        if (recent_start[i] && recent_views[0].id !== recent_start[i].id) {
          recent_views.push(recent_start[i]);
        }
      }
    }
    localStorage.setItem('recent_views',JSON.stringify(recent_views));
  }

  function get_recent(){
    //console.log('get start')
    const recent_start = JSON.parse(localStorage.getItem( 'recent_views'))
    const recent_block = document.body.querySelector('.js_product_recent')
    const recent_elements = document.body.querySelectorAll('.js_product_recent_item')

    if(!recent_start){
      recent_block.style.display = 'none'
      return
    }

    for(let i=0;i<5;i++){
      if(!recent_start[i]){
        recent_elements[i].style.display = 'none'
        continue
      }

      const link   = recent_elements[i].querySelector('a.el_cardProduct_link')
      const source = recent_elements[i].querySelector('source')
      const img    = recent_elements[i].querySelector('img')
      const title  = recent_elements[i].querySelector('.el_cardProduct_descTitleText')
      const vendor = recent_elements[i].querySelector('.el_cardProduct_descBrand')
      const price  = recent_elements[i].querySelector('.el_cardProduct_descPrice')

      link.setAttribute('href',recent_start[i].url)
      source.setAttribute('data-srcset',recent_start[i].tn)
      source.setAttribute('srcset',recent_start[i].tn)
      source.setAttribute('alt',recent_start[i].title)
      img.setAttribute('data-srcset',recent_start[i].tn+' 1x,'+recent_start[i].tn+' 2x')
      img.setAttribute('data-src',recent_start[i].tn)
      img.setAttribute('srcset',recent_start[i].tn+' 1x,'+recent_start[i].tn+' 2x')
      img.setAttribute('src',recent_start[i].tn)
      img.setAttribute('alt',recent_start[i],title)
      title.innerHTML = recent_start[i].title
      vendor.innerHTML = recent_start[i].vendor
      price.innerHTML = recent_start[i].price
    }
  }

  function set_frame(){
    const cards = document.body.querySelectorAll('.p_productDetail_history .el_cardProduct')
    const min = 1
    const max = 15
  
    cards.forEach( elm => {
        const rand = Math.floor( Math.random() * (max + 1 - min) ) + min
        elm.dataset.frame = 's' + rand
    })
  }

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommend"]) return;
  try {
    
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
        fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('product-recommendations');
              this._setFrame(recommendations)
              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }
            })
            .catch(e => {
              console.error(e);
            });
        /*
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
  
          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('product-recommendations');
              this._setFrame(recommendations)
              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }
            })
            .catch(e => {
              console.error(e);
            });
        }
  
        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
        */
      }

      _setFrame (html){
        //console.log(html)
        const cards = html.querySelectorAll('.el_cardProduct')
        const min = 1
        const max = 15
  
        cards.forEach( elm => {
          const rand = Math.floor( Math.random() * (max + 1 - min) ) + min
          elm.dataset.frame = 's' + rand
        })
      }
    }
  
    customElements.define('product-recommendations', ProductRecommendations);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      fetch(this.dataset.url).then(response => response.text()).then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      }).catch(e => {
        console.error(e);
      });

/*
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) 
          return;
        
        observer.unobserve(this);

        fetch(this.dataset.url).then(response => response.text()).then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        }).catch(e => {
          console.error(e);
        });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
      */
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
